import { inject } from "@angular/core";
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { IsWalletAvailableUseCase } from "@app/core/wallet/domain/usecase/is-wallet-available.use-case";
import { RedirectUrlService } from "@app/presentation/services/redirectUrl.service";
import { firstValueFrom } from "rxjs";

export const isWalletAvailableGuard: CanActivateFn = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const isWalletAvailableUseCase = inject(IsWalletAvailableUseCase);
    const router = inject(Router);
    const redirectUrlService = inject(RedirectUrlService);

    try {
        const isWalletAvailable = await firstValueFrom(isWalletAvailableUseCase.execute());
        if (!isWalletAvailable) {
            const currentPath = state.url;
            redirectUrlService.saveRedirectUrl(currentPath);
            await router.navigate(["/"], { replaceUrl: true });
            return false;
        }
        return true;
    } catch (error) {
        console.error('Error checking wallet visibility:', error);
        return false;
    }
};
